import React, { useState, useEffect } from "react";
import { Card, Input, Button, message, Space } from "antd";
import { CopyOutlined } from "@ant-design/icons";

const TokenBox = () => {
  const [token, setToken] = useState("");

 useEffect(() => {
   const storedUser = JSON.parse(localStorage.getItem("user"));

   if (storedUser?.token) {
     // ✅ Remove "Bearer " from start
     const cleanToken = storedUser.token.replace(/^Bearer\s+/i, "");
     setToken(cleanToken);
   }
 }, []);

  // ✅ Copy function
  const handleCopy = () => {
    if (!token) {
      message.warning("No token found");
      return;
    }

    navigator.clipboard.writeText(token);
    message.success("Token copied ✅");
  };

  return (
    <Card title="API Token">
      <Space>
        <Input value={token} readOnly style={{ width: 400 }} />

        <Button type="primary" icon={<CopyOutlined />} onClick={handleCopy}>
          Copy
        </Button>
      </Space>
    </Card>
  );
};

export default TokenBox;
